import React from 'react';
import { NavLink } from 'react-router-dom';
import { User, Building2, Lock, Users, FileCheck } from 'lucide-react';

export const SettingsTabsNav: React.FC = () => {
  const tabs = [
    { to: '/settings/profile', label: 'Personal Profile', icon: User },
    { to: '/settings/organization', label: 'Organization Profile', icon: Building2 },
    { to: '/settings/security', label: 'Security & Password', icon: Lock },
    { to: '/settings/team', label: 'Team Access', icon: Users },
    { to: '/settings/kyc', label: 'KYC & Verification', icon: FileCheck },
  ];

  return (
    <div className="flex border-b border-zinc-800 gap-2 overflow-x-auto">
      {tabs.map((tab) => {
        const Icon = tab.icon;
        return (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              `flex items-center gap-2 px-4 py-3 text-xs font-medium border-b-2 transition whitespace-nowrap cursor-pointer ${
                isActive
                  ? 'border-indigo-500 text-indigo-400 font-semibold'
                  : 'border-transparent text-zinc-400 hover:text-zinc-200'
              }`
            }
          >
            <Icon className="w-3.5 h-3.5" />
            <span>{tab.label}</span>
          </NavLink>
        );
      })}
    </div>
  );
};
